import { available, unavailable } from './integer.js';
import type { PoolMathResult, QuoteVenue, VenueResolutionInput } from './types.js';

export function resolveQuoteVenue(input: VenueResolutionInput): PoolMathResult<QuoteVenue> {
  if (
    !Number.isSafeInteger(input.outcomeIndex) ||
    input.outcomeIndex < 0 ||
    (input.winningOutcomeIndex !== null &&
      (!Number.isSafeInteger(input.winningOutcomeIndex) || input.winningOutcomeIndex < 0))
  ) {
    return unavailable('invalid_amount');
  }

  if (input.lifecycle === 'trading') {
    return input.bondingCurveClosed
      ? unavailable('bonding_curve_closed')
      : available('bonding_curve');
  }

  if (input.lifecycle === 'resolved') {
    if (input.winningOutcomeIndex === null) {
      return unavailable('missing_winning_outcome');
    }
    return input.outcomeIndex === input.winningOutcomeIndex
      ? unavailable('market_not_quotable')
      : unavailable('terminal_losing_outcome');
  }

  if (input.lifecycle !== 'graduated') {
    return unavailable('market_not_quotable');
  }
  if (input.winningOutcomeIndex === null) {
    return unavailable('missing_winning_outcome');
  }
  if (input.outcomeIndex !== input.winningOutcomeIndex) {
    return unavailable('terminal_losing_outcome');
  }
  if (!input.hasCpSwapPool) {
    return unavailable('missing_cp_swap_pool');
  }
  return available('cp_swap');
}
